import { HttpParams } from "@angular/common/http";

export function overrideMerge (p1: HttpParams, p2: HttpParams): HttpParams {
  let out: HttpParams = new HttpParams({ fromString: p1.toString() });

  for (const key of p2.keys()) {
    out = out[ "delete" ](key);

    for (const value of p2.getAll(key) ?? [])
      out = out.append(key, value);
  }

  return out;
}
